module.exports = __webpack_public_path__ + "assets/images/0c7c751933208b7a392c028fbac77414.avif";